'use client'

import { Icon, IconComponent } from '@graftcode/design-system'
import * as Dialog from '@radix-ui/react-dialog'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'

import styles from '../../MobileMenu.module.scss'

interface AddNewDrawerProps {
  /** Whether the drawer is open */
  isOpen: boolean
  /** Callback to close the drawer */
  onClose: () => void
  /** Callback when Add Service is clicked */
  onAddServiceClick: () => void
  /** Callback when Add Project is clicked */
  onAddProjectClick: () => void
  /** Callback when Add Workspace is clicked */
  onAddWorkspaceClick: () => void
}

export function AddNewDrawer({
  isOpen,
  onClose,
  onAddServiceClick,
  onAddProjectClick,
  onAddWorkspaceClick,
}: AddNewDrawerProps) {
  const handleAddService = () => {
    onAddServiceClick()
    onClose()
  }

  const handleAddProject = () => {
    onAddProjectClick()
    onClose()
  }

  const handleAddWorkspace = () => {
    onAddWorkspaceClick()
    onClose()
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.appPickerOverlay} />
        <Dialog.Content className={styles.addNewDrawer} data-testid={MOBILE_MENU_TEST_IDS.addNewDrawer}>
          {/* Header */}
          <div className={styles.appPickerHeader}>
            <div className={styles.appPickerDragHandle} />
            <Dialog.Title className={styles.appPickerTitle}>Add new</Dialog.Title>
            <div className={styles.appPickerDivider} />
          </div>

          {/* Content */}
          <div className={styles.addNewDrawerContent}>
            <button className={styles.addNewDrawerItem} onClick={handleAddService}>
              <IconComponent icon={Icon.AddRegular} size={24} className={styles.addNewDrawerItemIcon} />
              <span className={styles.addNewDrawerItemLabel}>Add service</span>
            </button>

            <button className={styles.addNewDrawerItem} onClick={handleAddProject}>
              <IconComponent icon={Icon.FolderRegular} size={24} className={styles.addNewDrawerItemIcon} />
              <span className={styles.addNewDrawerItemLabel}>Add project</span>
            </button>

            <button className={styles.addNewDrawerItem} onClick={handleAddWorkspace}>
              <IconComponent
                icon={Icon.OrganizationHorizontalRegular}
                size={24}
                className={styles.addNewDrawerItemIcon}
              />
              <span className={styles.addNewDrawerItemLabel}>Add Workspace</span>
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
